import React from 'react';

import type { ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import getTagsTableColumns from './TagsTableColumns';
import buttons from './TagsButtons';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));

const routes: AppRouteGroup = {
	settings: {},
	routes: [
		{
			path: 'tags/:tabId?',
			element: (
				<ViewPage
					module="tags"
					content={{ type: 'table', getColumns: getTagsTableColumns }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
